export default __webpack_public_path__ + "static/media/41.8a5ee2b7.png";